module.exports = __webpack_public_path__ + "static/media/codequiz.a89306fe.png";